import { createSchema } from '../../../common/helpers/Schema';

export default createSchema({
    username: {
        label: 'Email Address',
    },
});
